import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
export const constantRouterMap = [{
        path: '/',
        name: 'login',
        component: () =>
            import ('@/views/login'),
        hidden: true
    },
    {
        "path": "/portableKanban",
        "name": "portableKanban",
        "title": "大屏看板",
        "component": () =>
            import ("@/views/portableKanban")
    },
    {
        path: '/main',
        component: () =>
            import ('@/views/main'),
        redirect: '/home',
        title: "首页",
        name: 'home',
        hidden: true,
        children: [{
                "path": "/home",
                "name": "home",
                "title": "首页",
                "component": () =>
                    import ("@/views/home")
            },
            {
                "path": "/portableEquip",
                "title": "设备管理",
                "name": "portableEquip",
                "component": () =>
                    import ("@/views/portableEquip")
            },
            {
                "path": "/portableData",
                "title": "原始数据",
                "name": "portableData",
                "meta": {
                    "remember": true
                },
                "component": () =>
                    import ("@/views/portableData")
            }, {
                "path": "/portablePersonalCenter",
                "title": "个人中心",
                "name": "portablePersonalCenter",
                "component": () =>
                    import ("@/views/portablePersonalCenter")
            }, {
                "path": "/portableTargetData",
                "title": "定标数据",
                "name": "portableTargetData",
                "component": () =>
                    import ("@/views/portableTargetData")
            }, {
                "path": "/skinManagement",
                "title": "皮肤管理",
                "name": "skinManagement",
                "component": () =>
                    import ("@/views/skinManagement")
            }, {
                "path": "/portableUser",
                "title": "用户管理",
                "name": "portableUser",
                "component": () =>
                    import ("@/views/portableUser")
            }, {
                "path": "/scenesManagement",
                "title": "场景管理",
                "name": "scenesManagement",
                "component": () =>
                    import ("@/views/scenesManagement")
            }, {
                "path": "/portablePoint",
                "title": "点位管理",
                "name": "portablePoint",
                "component": () =>
                    import ("@/views/portablePoint")
            }, {
                "path": "/portableInversion",
                "title": "反演数据",
                "name": "portableInversion",
                "component": () =>
                    import ("@/views/portableInversion")
            }, {
                "path": "/firmWareManagement",
                "title": "固件版本",
                "name": "firmWareManagement",
                "component": () =>
                    import ("@/views/firmWareManagement")
            }, {
                "path": "/portableBaseline",
                "title": "本底数据",
                "name": "portableBaseline",
                "component": () =>
                    import ("@/views/portableBaseline")
            }, {
                "path": "/userPoint",
                "title": "用户点位",
                "name": "userPoint",
                "component": () =>
                    import ("@/views/userPoint")
            }, {
                "path": "/equipVersion",
                "title": "设备型号",
                "name": "equipVersion",
                "component": () =>
                    import ("@/views/equipVersion")
            }, {
                "path": "/portableCustomerManagement",
                "title": "客户管理",
                "name": "portableCustomerManagement",
                "component": () =>
                    import ("@/views/portableCustomerManagement")
            }, {
                "path": "/portableWaterData",
                "title": "水色数据",
                "name": "portableWaterData",
                "component": () =>
                    import ("@/views/portableWaterData")
            }, {
                "path": "/portableSmartData",
                "title": "思能数据",
                "name": "portableSmartData",
                "component": () =>
                    import ("@/views/portableSmartData")
            }, {
                "path": "/portableWaterDataMan",
                "title": "水色数据",
                "name": "portableWaterDataMan",
                "component": () =>
                    import ("@/views/portableWaterDataMan")
            }, {
                "path": "/portableSmartDataMan",
                "title": "思能数据",
                "name": "portableSmartDataMan",
                "component": () =>
                    import ("@/views/portableSmartDataMan")
            }, {
                "path": "/portableEquipTarget",
                "title": "设备定标",
                "name": "portableEquipTarget",
                "component": () =>
                    import ("@/views/portableEquipTarget")
            }, {
                "path": "/spectralDatabase",
                "title": "光谱数据库",
                "name": "spectralDatabase",
                "component": () =>
                    import ("@/views/spectralDatabase")
            }, {
                "path": "/targetDatabase",
                "title": "定标数据库",
                "name": "targetDatabase",
                "component": () =>
                    import ("@/views/targetDatabase")
            }, {
                "path": "/portableAlgoManagement",
                "title": "算法管理",
                "name": "portableAlgoManagement",
                "component": () =>
                    import ("@/views/portableAlgoManagement")
            }, {
                "path": "/userAlgo",
                "title": "用户算法管理",
                "name": "userAlgo",
                "component": () =>
                    import ("@/views/userAlgo")
            }, {
                "path": "/userEquip",
                "title": "用户设备管理",
                "name": "userEquip",
                "component": () =>
                    import ("@/views/userEquip")
            }, {
                "path": "/newKanban",
                "title": "用户设备管理",
                "name": "newKanban",
                "component": () =>
                    import ("@/views/newKanban")
            },
            {
                "path": "/spectralComparison",
                "title": "光谱比对",
                "name": "spectralComparison",
                "component": () =>
                    import ("@/views/spectralComparison")
            },
            {
                "path": "/microPointCodeManagement",
                "title": "微点码管理",
                "name": "microPointCodeManagement",
                "component": () =>
                    import ("@/views/microPointCodeManagement")
            },
            {
                "path": "/microPointCodeManagementUser",
                "title": "用户微点码管理",
                "name": "microPointCodeManagementUser",
                "component": () =>
                    import ("@/views/microPointCodeManagementUser")
            },
            {
                "path": "/spectralDatabaseUser",
                "title": "用户光谱数据库",
                "name": "spectralDatabaseUser",
                "component": () =>
                    import ("@/views/spectralDatabaseUser")
            },
            // ...otherModulesRouter
        ]
    }
]
export default new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap
})


// WEBPACK FOOTER //
// ./src/router/index.js